(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

document.addEventListener("DOMContentLoaded", function () {
  // Don't touch
  // Don't touch
  objectFitImages();
  svg4everybody();
  // End don't touch

  require('./modules/animations');
  require('./modules/video');
  require('./modules/slider');
  require('./modules/modal');
  require('./modules/menu');
  require('./modules/form');
  require('./modules/g-map');
  require('./modules/tooltip');
  require('./modules/speakers');
  // require('./modules/gallery-animations');
  require('./modules/header');
});

// remove preloader
window.addEventListener('load', function () {
  document.querySelector('html').classList.add('page-loaded');
  AOS.init({
    once: true,
    useClassNames: true,
    duration: 500,
    delay: 200,
    // easing: 'linear',
    // easing: 'ease',
    // easing: 'ease-in',
    // easing: 'ease-out',
    // easing: 'ease-in-out',
    // easing: 'ease-in-back',
    // easing: 'ease-out-back',
    // easing: 'ease-in-out-back',
    // easing: 'ease-in-sine',
    // easing: 'ease-out-sine',
    // easing: 'ease-in-out-sine',
    // easing: 'ease-in-quad',
    // easing: 'ease-out-quad',
    // easing: 'ease-in-out-quad',
    // easing: 'ease-in-cubic',
    // easing: 'ease-out-cubic',
    // easing: 'ease-in-out-cubic',
    // easing: 'ease-in-quart',
    // easing: 'ease-out-quart',
    easing: 'ease-in-out-quart'
  });
});

},{"./modules/animations":2,"./modules/form":3,"./modules/g-map":4,"./modules/header":5,"./modules/menu":6,"./modules/modal":7,"./modules/slider":8,"./modules/speakers":9,"./modules/tooltip":10,"./modules/video":11}],2:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
(function () {
  gsap.registerPlugin(ScrollTrigger);
  var Button = /*#__PURE__*/function () {
    function Button(buttonElement) {
      _classCallCheck(this, Button);
      this.block = buttonElement;
      this.init();
      this.initEvents();
    }
    return _createClass(Button, [{
      key: "init",
      value: function init() {
        var el = gsap.utils.selector(this.block);
        this.DOM = {
          button: this.block,
          flair: el(".button__flair")
        };
        this.xSet = gsap.quickSetter(this.DOM.flair, "xPercent");
        this.ySet = gsap.quickSetter(this.DOM.flair, "yPercent");
      }
    }, {
      key: "getXY",
      value: function getXY(e) {
        var _this$DOM$button$getB = this.DOM.button.getBoundingClientRect(),
          left = _this$DOM$button$getB.left,
          top = _this$DOM$button$getB.top,
          width = _this$DOM$button$getB.width,
          height = _this$DOM$button$getB.height;
        var xTransformer = gsap.utils.pipe(gsap.utils.mapRange(0, width, 0, 100), gsap.utils.clamp(0, 100));
        var yTransformer = gsap.utils.pipe(gsap.utils.mapRange(0, height, 0, 100), gsap.utils.clamp(0, 100));
        return {
          x: xTransformer(e.clientX - left),
          y: yTransformer(e.clientY - top)
        };
      }
    }, {
      key: "initEvents",
      value: function initEvents() {
        var _this = this;
        this.DOM.button.addEventListener("mouseenter", function (e) {
          var _this$getXY = _this.getXY(e),
            x = _this$getXY.x,
            y = _this$getXY.y;
          _this.xSet(x);
          _this.ySet(y);
          gsap.to(_this.DOM.flair, {
            scale: 1,
            duration: 0.4,
            ease: "power2.out"
          });
        });
        this.DOM.button.addEventListener("mouseleave", function (e) {
          var _this$getXY2 = _this.getXY(e),
            x = _this$getXY2.x,
            y = _this$getXY2.y;
          gsap.killTweensOf(_this.DOM.flair);
          gsap.to(_this.DOM.flair, {
            xPercent: x > 90 ? x + 20 : x < 10 ? x - 20 : x,
            yPercent: y > 90 ? y + 20 : y < 10 ? y - 20 : y,
            scale: 0,
            duration: 0.3,
            ease: "power2.out"
          });
        });
        this.DOM.button.addEventListener("mousemove", function (e) {
          var _this$getXY3 = _this.getXY(e),
            x = _this$getXY3.x,
            y = _this$getXY3.y;
          gsap.to(_this.DOM.flair, {
            xPercent: x,
            yPercent: y,
            duration: 0.4,
            ease: "power2"
          });
        });
      }
    }]);
  }();
  var buttonElements = document.querySelectorAll('[data-block="button"]');

  // buttonElements.forEach((buttonElement) => {
  //   new Button(buttonElement);
  // });

  gsap.utils.toArray('.block-with-line, .post-quote--with-line').forEach(function (el) {
    ScrollTrigger.create({
      trigger: el,
      start: 'top 90%',
      onEnter: function onEnter() {
        el.querySelector('svg path').classList.add('animated');
      }
    });
  });
  gsap.utils.toArray('[data-animate="horizontal-scroll"]').forEach(function (parallaxElement) {
    gsap.to(parallaxElement.children, {
      x: 0,
      scrollTrigger: {
        trigger: parallaxElement,
        start: 'top 60%',
        end: 'top 0',
        scrub: 1
        // markers: true,
      }
    });
  });
})();

},{}],3:[function(require,module,exports){
"use strict";

function initForm() {
  var element = document.querySelector('.js-choice');
  var choicesData = [{
    value: 'Launch, relocate, or expand a business in Southern Nevada',
    label: '<strong>Launch, relocate, or expand</strong> a business in Southern Nevada',
    selected: false
  }, {
    value: 'Learn about real estate opportunities, tax abatements, and ways to save',
    label: '<strong>Learn</strong> about real estate opportunities, tax abatements, and ways to save',
    selected: false
  }, {
    value: 'Request a media interview or speaker',
    label: '<strong>Request</strong> a media interview or speaker',
    selected: false
  }, {
    value: 'Become an investor or sponsor',
    label: '<strong>Become</strong> an investor or sponsor',
    selected: false
  }, {
    value: 'Ask a general question',
    label: '<strong>Ask</strong> a general question',
    selected: false
  }];
  var choices = new Choices(element, {
    searchEnabled: false,
    itemSelectText: "",
    placeholder: true,
    placeholderValue: 'Request type',
    choices: choicesData,
    allowHTML: true
  });
}
if (document.querySelector('.js-choice')) {
  window.addEventListener('load', initForm);
}

},{}],4:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
(function () {
  var $map = document.getElementById('map');
  var map;
  if ($map) {
    var markerLng = parseFloat($map.getAttribute('data-marker-lng'));
    var markerLat = parseFloat($map.getAttribute('data-marker-lat'));
    initMap($map, markerLng, markerLat);
  }
  function initMap(_x, _x2, _x3) {
    return _initMap.apply(this, arguments);
  }
  function _initMap() {
    _initMap = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee($map, markerLng, markerLat) {
      var location, _yield$google$maps$im, Map, _yield$google$maps$im2, AdvancedMarkerElement, _yield$google$maps$im3, ColorScheme, markerIcon, marker;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            location = {
              lat: markerLat,
              lng: markerLng
            };
            _context.next = 3;
            return google.maps.importLibrary("maps");
          case 3:
            _yield$google$maps$im = _context.sent;
            Map = _yield$google$maps$im.Map;
            _context.next = 7;
            return google.maps.importLibrary("marker");
          case 7:
            _yield$google$maps$im2 = _context.sent;
            AdvancedMarkerElement = _yield$google$maps$im2.AdvancedMarkerElement;
            _context.next = 11;
            return google.maps.importLibrary("core");
          case 11:
            _yield$google$maps$im3 = _context.sent;
            ColorScheme = _yield$google$maps$im3.ColorScheme;
            map = new Map($map, {
              zoom: 10,
              center: location,
              disableDefaultUI: true,
              mapId: 'google_map',
              colorScheme: ColorScheme.DARK
              // styles: [
              //   {
              //     "elementType": "geometry",
              //     "stylers": [
              //       {
              //         "color": "#24355F"
              //       }
              //     ]
              //   },
              //   {
              //     "featureType": "landscape",
              //     "elementType": "geometry",
              //     "stylers": [
              //       {
              //         "color": "#06364E"
              //       }
              //     ]
              //   },
              //   {
              //     "elementType": "labels.icon",
              //     "stylers": [
              //       {
              //         "visibility": "off"
              //       }
              //     ]
              //   },
              //   {
              //     "elementType": "labels.text.fill",
              //     "stylers": [
              //       {
              //         "color": "#80B7AD"
              //       }
              //     ]
              //   },
              //   {
              //     "elementType": "labels.text.stroke",
              //     "stylers": [
              //       {
              //         "color": "#192E40"
              //       }
              //     ]
              //   },
              //   {
              //     "featureType": "administrative.land_parcel",
              //     "elementType": "labels.text.fill",
              //     "stylers": [
              //       {
              //         "color": "#356B75"
              //       }
              //     ]
              //   },
              //   {
              //     "featureType": "administrative.land_parcel",
              //     "elementType": "labels.text.stroke",
              //     "stylers": [
              //       {
              //         "color": "#172946"
              //       }
              //     ]
              //   },
              //   {
              //     "featureType": "poi",
              //     "elementType": "labels.text.fill",
              //     "stylers": [
              //       {
              //         "color": "#356B75"
              //       }
              //     ]
              //   },
              //   {
              //     "featureType": "poi",
              //     "elementType": "labels.text.stroke",
              //     "stylers": [
              //       {
              //         "color": "#172946"
              //       }
              //     ]
              //   },
              //   {
              //     "featureType": "road",
              //     "elementType": "geometry",
              //     "stylers": [
              //       {
              //         "color": "#275B6A"
              //       }
              //     ]
              //   },
              //   {
              //     "featureType": "water",
              //     "elementType": "geometry",
              //     "stylers": [
              //       {
              //         "color": "#192E40"
              //       }
              //     ]
              //   }
              // ]
            });
            markerIcon = document.createElement("div");
            markerIcon.className = 'google-marker';
            markerIcon.innerHTML = "<svg width=\"25\" height=\"28\" viewBox=\"0 0 25 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M12.5 0.25C8.49554 0.25 5.24996 3.6075 5.24996 7.75C5.24996 11.9037 9.60789 17.8824 11.5654 20.3599C12.0499 20.9724 12.9476 20.9724 13.4322 20.3599C15.3909 17.8824 19.75 11.9037 19.75 7.75C19.75 3.6075 16.5044 0.25 12.5 0.25ZM12.5 5.07178C13.9306 5.07178 15.0889 6.27 15.0889 7.75C15.0889 9.22875 13.9294 10.4282 12.5 10.4282C11.0705 10.4282 9.91101 9.23 9.91101 7.75C9.91101 6.27 11.0693 5.07178 12.5 5.07178ZM6.45121 18.4556C6.35829 18.4559 6.26301 18.468 6.16801 18.4922C2.71822 19.3734 0.416626 20.95 0.416626 22.75C0.416626 25.5112 5.82633 27.75 12.5 27.75C19.1736 27.75 24.5833 25.5112 24.5833 22.75C24.5833 20.95 22.2817 19.3746 18.8319 18.4946C18.0719 18.3009 17.3333 18.9078 17.3333 19.7178C17.3333 20.2853 17.6984 20.7925 18.2301 20.9287C20.4111 21.4887 21.7367 22.2651 22.1053 22.7476C21.483 23.5663 18.1719 25.2476 12.5 25.2476C6.82804 25.2476 3.51694 23.5663 2.89465 22.7476C3.26199 22.2638 4.58877 21.4887 6.76982 20.9287C7.30148 20.7937 7.66663 20.2853 7.66663 19.7178C7.66663 19.0079 7.10169 18.4531 6.45121 18.4556Z\" fill=\"#00F592\"/>\n</svg>\n";
            marker = new AdvancedMarkerElement({
              position: location,
              map: map,
              content: markerIcon

              // icon: {
              //   url: 'assets/img/logos/pointer.svg',
              //   scaledSize: new google.maps.Size(30, 30)
              // }
            });
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _initMap.apply(this, arguments);
  }
})();

},{}],5:[function(require,module,exports){
"use strict";

(function () {
  var $header = document.querySelector('.header');
  if ($header) {
    var stickyHeader = function stickyHeader() {
      var st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > lastScrollTop) {
        // downscroll code
        $header.classList.remove('scrolled--visible');
        $header.style.top = '';
      } else {
        // upscroll code
        $header.classList.add('scrolled--visible');
        $header.style.top = '';
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

      $header.classList.toggle('scrolled', window.pageYOffset > sticky);
      if (window.pageYOffset <= sticky) {
        $header.classList.remove('scrolled--visible', 'scrolled');
        $header.style.top = top - window.pageYOffset + 'px';
      }
    };
    var topStr = window.getComputedStyle($header, null).getPropertyValue("top");
    var top = topStr.substr(0, topStr.length - 2);
    var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var sticky = document.body.scrollTop + $header.offsetTop;
    window.addEventListener('scroll', stickyHeader);
    window.addEventListener('load', stickyHeader);
  }
})();

},{}],6:[function(require,module,exports){
"use strict";

(function () {
  var $header = document.querySelector('.header');
  var $menu = document.querySelector('.main-nav');
  var $hamburger = document.querySelector('.burger');
  var $firstLevelLinks = document.querySelectorAll('.header .menu > .menu-item-has-children > a');
  var $secondLevelLinks = document.querySelectorAll('.header .menu .sub-menu > .menu-item-has-children > a');
  var $backLink = $header.querySelector('.back-link');
  var $footerNavItems = document.querySelectorAll('.footer__nav .menu-item-has-children');
  var $searchOpener = document.querySelector('.header__search-opener');
  var $searchForm = document.querySelectorAll('.search-form');
  var $search = document.querySelector('.header__search');
  var isMenuOpened = false;
  $hamburger.addEventListener('click', function () {
    this.classList.toggle('opened');
    $header.classList.toggle('opened');
    $header.classList.toggle('menu-opened');
    isMenuOpened = !isMenuOpened;
    if (isMenuOpened) {
      bodyScrollLock.disableBodyScroll($menu);
    } else {
      bodyScrollLock.clearAllBodyScrollLocks();
      $header.classList.remove('second-menu-opened');
      $header.classList.remove('third-menu-opened');
      $firstLevelLinks.forEach(function (item) {
        item.parentNode.classList.remove('opened');
      });
      $secondLevelLinks.forEach(function (item) {
        item.parentNode.classList.remove('opened');
      });
      $backLink.textContent = '';
      $backLink.classList.add('hidden');
    }
  });
  $firstLevelLinks.forEach(function (item) {
    item.addEventListener('click', function (e) {
      if (isMenuOpened) {
        e.preventDefault();
        var link = this.cloneNode(true);
        createBackLink(link, 2);
        $backLink.classList.remove('hidden');
        $header.classList.add('second-menu-opened');
        this.parentNode.classList.add('opened');
      }
    });
  });
  $secondLevelLinks.forEach(function (item) {
    item.addEventListener('click', function (e) {
      if (isMenuOpened) {
        e.preventDefault();
        var link = this.cloneNode(true);
        createBackLink(link, 3);
        $header.classList.add('third-menu-opened');
        this.parentNode.classList.add('opened');
      }
    });
  });
  $footerNavItems.forEach(function (item) {
    var submenu = item.querySelector('.sub-menu');
    item.addEventListener('click', function (e) {
      if (window.innerWidth < 768 && !item.classList.contains('opened')) {
        e.preventDefault();
        $footerNavItems.forEach(function (menuItem) {
          menuItem.classList.remove('opened');
        });
        item.classList.add('opened');
      }
    });
  });
  function createBackLink(link, level) {
    link.classList.add("level-".concat(level));
    $backLink.appendChild(link);
  }
  $backLink.addEventListener('click', function () {
    if ($header.classList.contains('third-menu-opened')) {
      $header.classList.remove('third-menu-opened');
      $header.classList.add('second-menu-opened');
      var link3 = $backLink.querySelector('.level-3');
      link3.remove();
      $secondLevelLinks.forEach(function (item) {
        item.parentNode.classList.remove('opened');
      });
    } else {
      $header.classList.remove('second-menu-opened');
      var link2 = $backLink.querySelector('.level-2');
      link2.remove();
      $backLink.classList.add('hidden');
      $firstLevelLinks.forEach(function (item) {
        item.parentNode.classList.remove('opened');
      });
    }
  });
  window.addEventListener('resize', debounce(function () {
    if (isMenuOpened && window.innerWidth >= 768) {
      bodyScrollLock.clearAllBodyScrollLocks();
    }
  }));
  if ($searchOpener) {
    $searchOpener.addEventListener('click', function () {
      $search.classList.add('opened');
      $search.querySelector('input[type="text"]').focus();
    });
  }
  $searchForm.forEach(function (search) {
    var $searchClose = search.querySelector('.search-form__close');
    var $searchInput = search.querySelector('input[type="text"]');
    $searchClose.addEventListener('click', function () {
      $search.classList.remove('opened');
      $searchInput.setAttribute('value', '');
      $searchInput.blur();
      search.reset();
    });
  });
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
})();

},{}],7:[function(require,module,exports){
"use strict";

(function () {
  var modalOpener = document.getElementById('show-subscribe');
  var modal = document.getElementById('subscribe-dialog');
  if (modalOpener && modal) {
    var close = modal.querySelector('.modal__close');
    modalOpener.addEventListener('click', function (e) {
      e.preventDefault();
      modal.showModal();
    });
    close.addEventListener('click', function (e) {
      e.preventDefault();
      modal.close();
    });
  }
})();

},{}],8:[function(require,module,exports){
"use strict";

(function () {
  $('.gallery-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 1000,
    lazyLoad: 'ondemand',
    // or 'progressive'
    infinite: true,
    responsive: [{
      breakpoint: 1300,
      settings: {
        arrows: false
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }]
  });
  $('.hero-slider').slick({
    autoplay: true,
    autoplaySpeed: 10000,
    speed: 1500,
    fade: true,
    arrows: false,
    dots: false
  });
  $('.hero-logo-slider').slick({
    lazyLoad: 'ondemand',
    // or 'progressive'
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 800,
    arrows: false,
    dots: false,
    vertical: true,
    verticalScrolling: true,
    infinite: true,
    slidesToShow: 1,
    useTransform: true,
    cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)'
  });
  $('.logo-slider').slick({
    variableWidth: true,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    responsive: [{
      breakpoint: 1024,
      settings: {
        arrows: false,
        centerMode: true
      }
    }]
  });
  $('.post-grid').on('destroy', function (ev, slick) {
    var carousel = $(this),
      reinit = debounce(function () {
        carousel.slick(slick.options);
        window.removeEventListener('resize', reinit);
      }, 500);

    // Assign our debounced callback to window.resize.
    window.addEventListener('resize', reinit);
  }).slick({
    mobileFirst: true,
    slidesToShow: 1,
    variableWidth: true,
    arrows: false,
    responsive: [{
      breakpoint: 1024,
      settings: 'unslick'
    }]
  });
  $('.team-slider').slick({
    // autoplay: true,
    // autoplaySpeed: 10000,
    // speed: 1500,
    arrows: true,
    dots: false
  });
  $('.testimonial-slider').slick({
    arrows: true,
    dots: false
  });
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
})();

},{}],9:[function(require,module,exports){
"use strict";

(function () {
  var speakersPopup = document.querySelector('.speaker-popup');
  if (speakersPopup) {
    var popupClose = speakersPopup.querySelector('.speaker-popup__close');
    var popupImage = speakersPopup.querySelector('.speaker-popup__image img');
    var popupTitle = speakersPopup.querySelector('.speaker-popup__title');
    var popupJob = speakersPopup.querySelector('.speaker-popup__job');
    var popupText = speakersPopup.querySelector('.speaker-popup__text');
    popupClose.addEventListener('click', function () {
      speakersPopup.classList.add('hidden');
      popupImage.setAttribute('src', '');
      popupTitle.textContent = '';
      popupJob.textContent = '';
      popupText.innerHTML = '';
    });
    var speakersCard = document.querySelectorAll('.speaker-card');
    speakersCard.forEach(function (card) {
      var opener = card.querySelector('.speaker-card__link');
      var cardImage = card.querySelector('.speaker-card__image img').getAttribute('src');
      var cardTitle = card.querySelector('.speaker-card__name').textContent;
      var cardJob = card.querySelector('.speaker-card__job').textContent;
      var cardText = card.querySelector('.speaker-card__full-text').innerHTML;
      opener.addEventListener('click', function (e) {
        e.preventDefault();
        popupImage.setAttribute('src', cardImage);
        popupTitle.textContent = cardTitle;
        popupJob.textContent = cardJob;
        popupText.innerHTML = cardText;
        speakersPopup.classList.remove('hidden');
      });
    });
  }
})();

},{}],10:[function(require,module,exports){
"use strict";

(function () {
  var tooltips = document.querySelectorAll('.tooltip');
  tooltips.forEach(function (tooltip) {
    var opener = tooltip.querySelector('.tooltip__opener');
    var closer = tooltip.querySelector('.tooltip__close');
    opener.addEventListener('click', function () {
      if (!tooltip.classList.contains('opened')) {
        tooltip.classList.add('opened');
      }
    });
    closer.addEventListener('click', function () {
      tooltip.classList.remove('opened');
    });
  });
})();

},{}],11:[function(require,module,exports){
"use strict";

(function () {
  var videoBlocks = document.querySelectorAll('.video-block');
  if (videoBlocks) {
    loadPlayer();
    videoBlocks.forEach(function (video) {
      var playButton = video.querySelector('.video-block__play');
      var overlay = video.querySelector('.video-block__overlay');
      var videoLink = playButton.getAttribute('data-src');
      var blockId = video.querySelector('.video-block__youtube').getAttribute('id');
      var videoId = videoLink.slice(-11);
      overlay.style.background = "url('https://img.youtube.com/vi/".concat(videoId, "/maxresdefault.jpg') 50% 50% no-repeat");
      overlay.style.backgroundSize = 'cover';
      playButton.addEventListener('click', function (e) {
        e.preventDefault();
        initYoutubePleayerForVideoBlock(videoId, blockId);
      });
    });
  }
  function onBlockPlayerReady(event) {
    var player = event.target;
    player.playVideo();
    var iframe = player.getIframe();
    var overlay = iframe.nextElementSibling;
    overlay.classList.add('hidden');
  }
  function initYoutubePleayerForVideoBlock(videoId, blockId) {
    console.log('youtube player for video block init');
    var player = new YT.Player(blockId, {
      height: '360',
      width: '640',
      videoId: videoId,
      playerVars: {
        'rel': 0,
        'enablejsapi': 1,
        'origin': window.location.origin
      },
      events: {
        'onReady': onBlockPlayerReady
      }
    });
  }
  function loadPlayer() {
    console.log('loading youtube api');
    if (typeof YT == 'undefined' || typeof YT.Player == 'undefined') {
      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }
})();

},{}]},{},[1]);
